module.exports = __webpack_public_path__ + "img/gb13871-92-6x16x7.prt.cf42f05f.jpg";